import React, {useMemo} from 'react';
import {DetailPage, Layout, NoData, Tab, Tabs, Title} from '@mc/ui-v4';
import {DAVKA_DTM_PAGE_KEY} from '../const/PageKeys';
import {RouteComponentProps} from 'react-router-dom';
import {useHistory} from 'react-router';
import {getDtmDetailUrl} from '../utils/urlRedirectUtils';
import {DtmTabs, getDtmTabsContent, getDtmTabsItems} from '../enums/DtmTabs';

type Props = RouteComponentProps<{id: string; tab: string}>;
export const DtmDetailPage: React.FC<Props> = ({
    match: {
        params: {id, tab},
    },
}) => {
    const idNum = parseInt(id);
    const history = useHistory();

    const tabOptions = useMemo<{id: DtmTabs; name: string}[]>(() => getDtmTabsItems(), []);
    const DtmTabsContent = useMemo(() => getDtmTabsContent(tab), [tab]);

    return (
        <DetailPage currentPage={DAVKA_DTM_PAGE_KEY} header={<Title type={'page'}>Detail změny DTM</Title>}>
            <Layout
                h100
                spacing={'2'}
                header={
                    <Tabs>
                        {tabOptions.map(item => (
                            <Tab
                                key={item.id}
                                onSelect={() => {
                                    history.push(getDtmDetailUrl(idNum, item?.id));
                                }}
                                active={item?.id === tab}
                            >
                                {item.name}
                            </Tab>
                        ))}
                    </Tabs>
                }
            >
                {tabOptions.some(t => t.id === tab) ? <DtmTabsContent id={idNum} /> : <NoData>Nepodporovaný typ podkladů</NoData>}
            </Layout>
        </DetailPage>
    );
};
